export const currencyEs = {
  Dashboard: `Panel`,
  catalog: `Catálogo`,
  currencies: `Monedas`,
  currency: `Moneda`,
  add_currency: `Añadir moneda`,
  edit_currency: `Editar moneda`,
  delete_currency: `Eliminar moneda`,
  delete_currency_description: `¿Seguro que quieres eliminar esta moneda? Esta acción no se puede deshacer.`,
  code: `Código`,
  name: `Nombre`,
  actions: `Acciones`,
  search: `Buscar`,
  search_placeholder: `Buscar por código o nombre`,
  filter_currencies: `Filtrar monedas`,
  filter_currencies_subtitle: `Acota la lista de monedas`,
  edit: `Editar`,
  delete: `Eliminar`,
  cancel: `Cancelar`,
  add: `Añadir`,
  update: `Actualizar`,
  code_required: `El código es obligatorio`,
  name_required: `El nombre es obligatorio`,
  no_currencies_found: `No se encontraron monedas`,
  currency_created_successfully: `Moneda creada correctamente`,
  currency_updated_successfully: `Moneda actualizada correctamente`,
  currency_deleted_successfully: `Moneda eliminada correctamente`,
  something_went_wrong: `Algo salió mal`,
  organization_not_found: `No se encontró organización para el usuario actual`,
  currency_code_required: `El código de la moneda es obligatorio`,
  currency_name_required: `El nombre de la moneda es obligatorio`,
  currency_code_duplicate: `Ya existe una moneda con este código`,
  currency_not_found: `Moneda no encontrada`,
  not_allowed_to_update_currency: `No tienes permiso para actualizar esta moneda`,
  not_allowed_to_delete_currency: `No tienes permiso para eliminar esta moneda`,
  currency_listing_max_100_allowed: `Se pueden listar como máximo 100 monedas por página`,
};
